import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/irSearchActions';

import Status from './Status';

const type = 'status_pending';
const noDataFoundMessage = 'There are no pending statuses.';

export class StatusController extends Component {
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

    getData = () => {
      this.props.dispatch(irActions.getCaseData({
        type,
        case_uuid: this.props.case_uuid,
      }));
    }

  purchaseData = () => {
    this.props.dispatch(irActions.purchaseCaseData({
      type,
      case_uuid: this.props.case_uuid,
    }));
  }

  render() {
    return (
      <Status
        {...this.props}
        type={type}
        purchaseData={this.purchaseData}
        noDataFoundMessage={noDataFoundMessage}
      />
    );
  }
}

StatusController.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

StatusController.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  statuses: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  return {
    dataReady: irSearch.data_ready,
    statuses: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusController);



// WEBPACK FOOTER //
// ./src/components/case/status/StatusContainer.js